import {ApiProtectedWS as http} from "../api/axios";
import {baseURL} from "../util/Constants";

class InteroperabilityService {

  getInfoConnection(tool:string) {
    return http?.get(baseURL.interoperabilityApi.manage + '/connection/' + tool);
  }

  getProjects(dominio:string, token:string, tool:string, email?:string) {
    let email_ = email || '';
    return http?.get(baseURL.interoperabilityApi.manage + '/projects?dominio='+dominio+'&token='+token+"&email="+email_+"&tool="+tool);
  }

  getConfigScreenEstimation(tool:string) {
    return http?.get(baseURL.interoperabilityApi.config + '/screen-estimation?tool='+tool);
  }

  updateRelatedUsers(data:any) {
    return http?.post(baseURL.interoperabilityApi.config + '/related-users', data);
  }

  relatedStatusesByProject(data:any) {
    return http?.post(baseURL.interoperabilityApi.config + '/related-status', data);
  }
  
  get(idProject: number) {
      return http?.get(baseURL.interoperabilityApi.config + `/project/${idProject}`);
  }

  writeAsync(idProject:number, managedState:boolean) {
    return http?.get(baseURL.interoperabilityApi.sync + `/write?idProject=${idProject}&managedState=${managedState}`);
  }

  writeAsyncInstance() {
    return http?.get(baseURL.interoperabilityApi.sync + `/writeInstance`);
  }

  sendNewStatus(data:any) {
    return http?.post(baseURL.interoperabilityApi.sync + `/sendNewStatus`, data);
  }

  reviewProjectElementStatus(idProjectElement:number) {
    return http?.post(baseURL.interoperabilityApi.sync + `/sendStatePei/${idProjectElement}`);

  }
}

export default InteroperabilityService;